import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox } from '@ardoq/layout';
import { connect } from '@ardoq/rxbeach';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t, type WithI18nLocale } from '@ardoq/i18n';
import { map } from 'rxjs';

const DisabledViewReplacementBase = ({ i18nLocale }: WithI18nLocale) => (
  <FlexBox
    height="full"
    width="full"
    align="center"
    justify="center"
    backgroundColor="surfaceDefault"
  >
    <ResponsiveDoqWithSpeechBubble
      doqType={DoqType.LOCKED}
      message={t(
        i18nLocale,
        'tabview:disabledView.message',
        'This view is not enabled for your organization. Contact your Ardoq admin or Ardoq support to turn it on.'
      )}
      title={t(
        i18nLocale,
        'tabview:disabledView.title',
        'This view is not enabled'
      )}
    />
  </FlexBox>
);

const disabledViewReplacementViewModel$ = i18nLocale$.pipe(
  map((i18nLocale): WithI18nLocale => ({ i18nLocale }))
);

export const DisabledViewReplacement = connect(
  DisabledViewReplacementBase,
  disabledViewReplacementViewModel$
);
